import foxyBrown from "./avatars/foxy_brown.png";
import foxyBlonde from "./avatars/foxy_blonde.png";
import locoBrown from "./avatars/loco_brown.png";
import locoBlonde from "./avatars/loco_blonde.png";
import foxNeutral from "./avatars/fox_no_gender.png";

export const INSTRUCTOR_AVATAR_PRESETS = [
    { id: "foxy-brown", src: foxyBrown, label: "Foxy Roxy, brown hair" },
    { id: "foxy-blonde", src: foxyBlonde, label: "Foxy Roxy, blonde hair" },
    { id: "loco-brown", src: locoBrown, label: "Fox Loco, brown hair" },
    { id: "loco-blonde", src: locoBlonde, label: "Fox Loco, blonde hair" },
    { id: "fox-neutral", src: foxNeutral, label: "Fox, neutral" },
];
